import React, { useEffect, useState } from "react";
import api, { formatApiError } from "../lib/api";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Label } from "./ui/label";
import { Switch } from "./ui/switch";
import DatePickerInput from "./DatePickerInput";

const iso = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
const addDays = (s, n) => { const d = new Date(s + "T12:00:00"); d.setDate(d.getDate() + n); return iso(d); };

// Duplica una campagna (parametri, prodotti e scheda) con nuove date: la copia nasce non attiva e non pubblicata
export default function CampaignCloneDialog({ campaign, open, onClose, onCloned }) {
  const [form, setForm] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    if (!open || !campaign) return;
    const dur = Math.max(Math.round((new Date(campaign.ends_at.slice(0, 10) + "T12:00:00") - new Date(campaign.starts_at.slice(0, 10) + "T12:00:00")) / 86400000), 0);
    const starts = iso(new Date());
    setForm({ name: `${campaign.name} (copia)`, starts_at: starts, ends_at: addDays(starts, dur), active: false });
  }, [open, campaign]);
  if (!form) return null;
  const submit = async () => {
    setBusy(true);
    try {
      const { data } = await api.post(`/campaigns/${campaign.id}/clone`, form);
      toast.success(`Campagna duplicata: ${data.name}`);
      onCloned?.(data);
      onClose();
    } catch (e) { toast.error(formatApiError(e)); } finally { setBusy(false); }
  };
  const inp = "bg-zinc-950 border-zinc-800";
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-md bg-zinc-900 border-zinc-800 text-zinc-100" data-testid="campaign-clone-dialog">
        <DialogHeader><DialogTitle>Duplica iniziativa · {campaign.name}</DialogTitle></DialogHeader>
        <div className="space-y-3 text-sm">
          <p className="text-xs text-zinc-400">Copia moltiplicatore, prodotti, testi e scheda grafica. La nuova campagna nasce <b>non attiva</b> e con la scheda <b>non pubblicata</b>: controllala e attivala quando sei pronto.</p>
          <div><Label className="text-xs">Nome</Label><Input value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className={inp} data-testid="campaign-clone-name" /></div>
          <div className="grid grid-cols-2 gap-2 [&>div]:min-w-0">
            <div><Label className="text-xs">Inizio</Label><DatePickerInput testid="campaign-clone-start" value={form.starts_at} max={form.ends_at} onChange={(e) => setForm({ ...form, starts_at: e.target.value })} /></div>
            <div><Label className="text-xs">Fine</Label><DatePickerInput testid="campaign-clone-end" value={form.ends_at} min={form.starts_at} onChange={(e) => setForm({ ...form, ends_at: e.target.value })} /></div>
          </div>
          <label className="flex items-center gap-2 rounded-lg border border-zinc-800 p-2"><Switch checked={form.active} onCheckedChange={(v) => setForm({ ...form, active: v })} data-testid="campaign-clone-active" /> Attiva subito</label>
          <Button onClick={submit} disabled={busy || !form.name || !form.starts_at || !form.ends_at} className="w-full" data-testid="campaign-clone-submit">{busy ? "Duplico…" : "Duplica"}</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
